import { Component, ElementRef, Input } from '@angular/core';
import { moveToAnimation } from '../../animations/index';
export class CbjGalleryItemComponent {
   clickE: (arg: { i: CbjGalleryItemComponent, e: Event }) => {};
   classes: string[];
   src: string;

  // Variables set/changed by the gallery component
   id: number;
   state = 'hidden';
   column: number;
   height: string;
   width: string;
   top = '100%';
   left = '0px';
/**
 * @param {?} e
 * @return {?}
 */
onClick(e: Event) {
    this.clickE({i: this, e: e});
  }
/**
 * @param {?} el
 */
constructor(public el: ElementRef) {}
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'cbj-gallery-item',
  template: `<img [@moveTo]="{value: state, params: { st: '100%', sl: '15px', et: top, el: left} }" 
                  [src]="src" 
                  (click)="onClick($event)" 
                  [ngClass]="classes" 
                  [style.top]="top" 
                  [style.left]="left"
                  [style.height]="height"
                  [style.width]="width">`,
  styles: ['img { position: absolute; }'],
  animations: [
    moveToAnimation()
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'clickE': [{ type: Input, args: ['clickE', ] },],
'classes': [{ type: Input, args: ['classes', ] },],
'src': [{ type: Input, args: ['src', ] },],
'id': [{ type: Input },],
'state': [{ type: Input },],
'column': [{ type: Input },],
'height': [{ type: Input },],
'width': [{ type: Input },],
'top': [{ type: Input },],
'left': [{ type: Input },],
};
}

function CbjGalleryItemComponent_tsickle_Closure_declarations() {
/** @type {?} */
CbjGalleryItemComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CbjGalleryItemComponent.ctorParameters;
/** @type {?} */
CbjGalleryItemComponent.propDecorators;
/** @type {?} */
CbjGalleryItemComponent.prototype.clickE;
/** @type {?} */
CbjGalleryItemComponent.prototype.classes;
/** @type {?} */
CbjGalleryItemComponent.prototype.src;
/** @type {?} */
CbjGalleryItemComponent.prototype.id;
/** @type {?} */
CbjGalleryItemComponent.prototype.state;
/** @type {?} */
CbjGalleryItemComponent.prototype.column;
/** @type {?} */
CbjGalleryItemComponent.prototype.height;
/** @type {?} */
CbjGalleryItemComponent.prototype.width;
/** @type {?} */
CbjGalleryItemComponent.prototype.top;
/** @type {?} */
CbjGalleryItemComponent.prototype.left;
/** @type {?} */
CbjGalleryItemComponent.prototype.el;
}




interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
